
const priceFormatter = new Intl.NumberFormat() //форматируем цену


export default priceFormatter.format;